import Http from "@/commons/Http";

const path = 'api/text-fragment';

export default {

    async getAll(){
        return Http.get(`${path}`);
    },

    async save(dto, id = ''){
        return Http.post(`${path}/${id}`, dto);
    },

    async delete(id = ''){
        return Http.delete(`${path}/${id}`);
    },

    async getById(id){
        return Http.get(`${path}/${id}`);
    },

    async audit(sort, direction, page, size){
        const filters = {entity: "TextFragment"};
        return Http.post(`${path}/audit?sort=${sort || 'a.created'},${direction || 'asc'}&page=${page || 1}&size=${size || 10}`, {filters});
    },

    async pagination(sort, direction, page, size, filters = {}){
        return Http.post(`${path}/pagination?sort=${sort || 'tf.name'},${direction || 'asc'}&page=${page || 1}&size=${size || 10}`, filters);
    },

}